import { LinkButton, UIHeading3, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RecommendedVillages.css';
import { VillageItem } from './components/VillageItem';
import { IRecommendedVillage } from '../../types/recommendedVillages';

export interface IRecommendedVillagesProps {
  villageList: IRecommendedVillage[];
  onVillageClick: (id: number, position: number) => void;
  onShowAllClick(): void;
  link: string;
}

export const RecommendedVillages = React.forwardRef<HTMLDivElement, IRecommendedVillagesProps>(
  ({ villageList, onVillageClick, onShowAllClick, link }, ref) => {
    return (
      <div className={styles['wrapper']} ref={ref}>
        <div className={styles['heading']}>
          <UIHeading3>Рекомендуем коттеджные посёлки</UIHeading3>
        </div>
        <div className={styles['description']}>
          <UIText1>Охрана, зоны отдыха и удобная инфраструктура</UIText1>
        </div>
        <div className={styles['villages-list']}>
          {villageList.map((village, index) => (
            <VillageItem {...village} key={village.id} onClick={() => onVillageClick(village.id, index + 1)} />
          ))}
        </div>
        <div className={styles['villages-button']}>
          <LinkButton size="XS" theme="fill_secondary" onClick={onShowAllClick} href={link} target="_blank">
            Смотреть все посёлки
          </LinkButton>
        </div>
      </div>
    );
  },
);

RecommendedVillages.displayName = 'RecommendedVillages';
